import _awaitAsyncGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _wrapAsyncGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator";
export function isIterable(a) {
  var _a;

  return typeof ((_a = a) === null || _a === void 0 ? void 0 : _a[Symbol.iterator]) === "function";
}
export function isAsyncIterable(a) {
  var _a;

  return typeof ((_a = a) === null || _a === void 0 ? void 0 : _a[Symbol.asyncIterator]) === "function";
}
export function isIterator(a) {
  var _a;

  return typeof ((_a = a) === null || _a === void 0 ? void 0 : _a.next) === "function";
}
export function toIterator(iterable) {
  if (isIterable(iterable)) {
    return iterable[Symbol.iterator]();
  }

  if (isAsyncIterable(iterable)) {
    return iterable[Symbol.asyncIterator]();
  }

  throw new TypeError("toIterator: iterable must be type of Iterable or AsyncIterable");
} // eslint-disable-next-line @typescript-eslint/no-empty-function

export var empty = /*#__PURE__*/_regeneratorRuntime.mark(function empty() {
  return _regeneratorRuntime.wrap(function empty$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }
  }, empty);
}); // eslint-disable-next-line @typescript-eslint/no-empty-function

export var asyncEmpty = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));

  return function asyncEmpty() {
    return _ref.apply(this, arguments);
  };
}();
export var isNotNullable = function isNotNullable(a) {
  return a !== null && a !== undefined;
};